export const TemplateStatus = {
  Approved: "APPROVED",
};
